import { ErrorView } from '@atlassian/mpac-ui';
import React from 'react';
import ErrorWindow from './ErrorWindow.svg';
const HOME_PAGE_LINK = '/';
export default function ErrorPage() {
  return /*#__PURE__*/React.createElement(ErrorView, {
    homeLink: HOME_PAGE_LINK,
    heading: "Looks like you took a wrong turn",
    image: ErrorWindow,
    primaryMessage: "This report does not exist",
    statusCode: 404,
    hideGoBackLink: false
  });
}